// Change versions only when the published document content changes.
export const legalDocuments = {
  termsVersion: "2026-10-11",
  privacyVersion: "2026-10-11",
  termsPath: "/terms",
  privacyPath: "/privacy",
} as const;
